/**
 * Reveals each .guide-feature-row (media + content fade/slide in) as it
 * scrolls into view. Uses IntersectionObserver so there's no continuous
 * scroll-event listener.
 */
function initGuideFeatureRowsReveal() {
  const rows = document.querySelectorAll('.guide-feature-row');

  if (!rows.length) return;

  if (!('IntersectionObserver' in window)) {
    rows.forEach((row) => row.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );

  rows.forEach((row) => observer.observe(row));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGuideFeatureRowsReveal);
} else {
  initGuideFeatureRowsReveal();
}
